import { Injectable } from "@angular/core";
import { BaseService } from "../../@core/services/base.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment.dev";
import { IRequestAccess, REQUEST_ACCESS_STATUS } from "../../@core/models/model";

export enum REQUEST_VIEW {
    CURRENT = 'CURRENT',
    HISTORY = 'HISTORY'
}

@Injectable({ providedIn: 'root' })
export class RequestAccessService extends BaseService {

    apiUrl = environment.apiUrl + '/request-access';
    authUrl = environment.apiUrl + '/authentication';

    constructor(protected override http: HttpClient) {
        super(http);
    }

    getRequestAccessDetails(requestId: string) {
        return this.get<IRequestAccess>(this.authUrl + `/request-access-details/${requestId}`);
    }

    getRequests(view: REQUEST_VIEW = REQUEST_VIEW.CURRENT) {
        return this.get<IRequestAccess[]>(this.apiUrl, { view });
    }

    removeRequest(requestId: string) {
        return this.delete(this.apiUrl + `/${requestId}`);
    }

    approveRequest(data: { requestIds: string[], role: string }) {
        return this.post(this.apiUrl, data);
    }

    updateRequest(request: IRequestAccess) {
        return this.put(this.apiUrl, { request });
    }

    checkRequestExists(email: string) {
        return this.get<{
            exists: boolean,
            message: string
        }>(this.apiUrl + `/check-email`, { email })
    }

    requestForDeactivation(email: string, reason: string) {
        return this.post(this.apiUrl + `/deactivate`, { email, reason });
    }

    revokeDeactivation(email: string) {
        return this.post(this.apiUrl + `/revoke-deactivation`, { email });
    }

    approveDeactivation(requestIds: string[], transferEmail: string) {
        return this.post(this.apiUrl + `/approve-deactivation`, { requestIds, transferEmail });
    }

    transferOwnership(userIds: string[], transferEmail: string) {
        return this.post(this.apiUrl + `/transfer-ownership`, { userIds, transferEmail });
    }

    requestCredits(ask: number, agent: number) {
        return this.post(this.apiUrl + `/request-credits`, { ask, agent });
    }

    approveCreditRequest(requestId: string) {
        return this.post(this.apiUrl + `/approve-credits`, { requestId });
    }

    requestPlanChange(planId: string, planName: string, users: Array<{ userId?: string, userEmail?: string, userName?: string }>, pricingPrice?: number, pricingTerm?: string) {
        return this.post(this.apiUrl + `/request-plan-change`, { planId, planName, users, pricingPrice, pricingTerm });
    }

    approvePlanChange(requestId: string, chargeAmount?: number) {
        return this.post(this.apiUrl + `/approve-plan-change`, { requestId, chargeAmount });
    }

    requestPaymentForUserInvite(users: Array<{ email: string, role: string, planId?: string }>) {
        return this.post(this.apiUrl + `/request-payment-for-user-invite`, { users });
    }
}